import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { SourceProps } from 'gatsby-plugin-image/dist/src/components/picture'
import getImageProps from '@/components/atoms/Image/helpers/get-image-props'
import { getHeroImageSources } from './getHeroImageSources'
import { HeroImageProps } from './types'

// eslint-disable-next-line react/function-component-definition
export const HeroImage: React.FC<HeroImageProps> = ({ image, mobile_image, options = {}, ...rest }) => {
  const imageProps = image
    ? getImageProps(image, {
        smartCrop: false,
        toFormat: null,
        ...options
      })
    : null

  const mobileImageProps = mobile_image
    ? getImageProps(mobile_image, {
        smartCrop: false,
        toFormat: null,
        ...options
      })
    : null

  const sources: SourceProps[] = getHeroImageSources(imageProps, mobileImageProps)

  return (
    <GatsbyImage
      image={{
        layout: 'fullWidth',
        images: {
          sources
        },
        width: -1,
        height: 550
      }}
      {...rest}
      alt={image?.alt_tag || ''}
      className={rest.className}
      imgClassName={rest.imgClassName}
      title={image?.title || image?.caption}
      loading="eager"
    />
  )
}
